import { render, staticRenderFns } from "./chooseGroupCate.vue?vue&type=template&id=bae7e5bc&scoped=true&"
import script from "./chooseGroupCate.vue?vue&type=script&lang=js&"
export * from "./chooseGroupCate.vue?vue&type=script&lang=js&"
import style0 from "./chooseGroupCate.vue?vue&type=style&index=0&id=bae7e5bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae7e5bc",
  null
  
)

export default component.exports